import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import UserAccountPageContainer from 'buyside/components/container/UserAccount/UserAccountPageContainer';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';

import { userAccountUrl } from 'buyside/util/urlHelper';

const UserAccountPageRoot = () => {
  return (
    <Router basename={userAccountUrl()}>
      <ErrorBoundary pageName="the user account page">
        <UserAccountPageContainer />
      </ErrorBoundary>
    </Router>
  );
};

export default UserAccountPageRoot;
